import { combineReducers } from "redux";
import { all } from "redux-saga/effects";
import activityLogsReducer from "./reducer/activityLogsReducer";

import newsCategoryReducer from "./reducer/newsCategoryReducer";
import newsArticleReducer from "./reducer/newsArticleReducer";
import userReducer from "./reducer/userReducer";
import authReducer from "./reducer/authReducer";
import wardReducer from "./reducer/wardReducer";
import publicServiceLinksReducer from "./reducer/publicServiceLinksReducer";
import publicServiceCategoryReducer from "./reducer/publicServiceCategoryReducer";
import areaOfficersReducer from "./reducer/areaofficersReducer";
import appointmentReducer from "./reducer/appointmentsReducer";
import feedbacksReducer from "./reducer/feedbacksReducer";
import permissionReducer from "./reducer/permissionReducer";
import aiConversationsReducer from "./reducer/aiConversationsReducer";
import roleReducer from "./reducer/roleReducer";
import areasReducer from "./reducer/areasReducer";
import dashboardReducer from "./reducer/dashboardReducer";
import priorityRulesReducer from "./reducer/priorityRulesReducer";
import escalationSettingsReducer from "./reducer/escalationSettingsReducer";
import feedbackCasesReducer from "./reducer/feedbackCasesReducer";
import categorySettingsReducer from "./reducer/categorySettingsReducer";
import miniappAccountsReducer from "./reducer/miniappAccountsReducer";
import groupAreaReducer from "./reducer/groupAreaReducer";
import notificationsReducer from "./reducer/notificationsReducer";
import taskManagementsReducer from "./reducer/taskManagementsReducer";
import taskManagementCategoriesReducer from "./reducer/taskManagementCategoriesReducer";
import broadcastsReducer from "./reducer/broadcastsReducer";
import houseNumberRuleReducer from "./reducer/establishingHouseNumbersReducer";
import feedbackByOfficerReducer from "./reducer/feedbackByOfficerReducer";

const initialReducer = (state = {}, action) => state;

export const rootReducer = combineReducers({
  app: initialReducer,
  newsCategory: newsCategoryReducer,
  newsArticle: newsArticleReducer,
  user: userReducer,
  auth: authReducer,
  ward: wardReducer,
  publicServiceLinks: publicServiceLinksReducer,
  publicServiceCategory: publicServiceCategoryReducer,
  areaOfficers: areaOfficersReducer,
  appointment: appointmentReducer,
  feedbacks: feedbacksReducer,
  permission: permissionReducer,
  role: roleReducer,
  aiConversations: aiConversationsReducer,
  areas: areasReducer,
  dashboard: dashboardReducer,
  priorityRules: priorityRulesReducer,
  escalationSettings: escalationSettingsReducer,
  feedbackCases: feedbackCasesReducer,
  categorySettings: categorySettingsReducer,
  miniappAccounts: miniappAccountsReducer,
  groupArea: groupAreaReducer,
  notifications: notificationsReducer,
  tasks: taskManagementsReducer,
  taskManagementCategories: taskManagementCategoriesReducer,
  broadcasts: broadcastsReducer,
  houseNumberRule: houseNumberRuleReducer,
  feedbackByOfficer: feedbackByOfficerReducer,
  activityLogs: activityLogsReducer,
});

export function* rootSaga() {
  yield all([]);
}
